<script lang="ts">
	import { classes } from '@thearc-hq/ui-kit/utils';

	export let additionalClass: string;
	export let label: string;
	export let selected: boolean;
	export let disabled: boolean | undefined = undefined;
	export let color: string | undefined = undefined;
	export let secondaryColor: string | undefined = undefined;
</script>

<div
	on:click
	on:keydown
	role="button"
	tabindex={-1}
	data-test="color-filter-chip"
	class={classes(
		'p-2 border rounded-md text-p-12 select-none text-center flex items-center',
		selected
			? 'border-accent-primary'
			: 'border border-dark-quaternary hover:border-dark-terteriary',
		disabled ? 'opacity-50 bg-dark-background cursor-default ' : 'cursor-pointer',
		color ? 'capitalize' : 'uppercase',
		additionalClass
	)}
>
	{#if color && secondaryColor}
		<div class="flex">
			<div
				class="rounded-l-full h-5 w-2.5"
				style="background-color: {color}"
				data-test="primary-color"
			/>
			<div
				class="rounded-r-full h-5 w-2.5 mr-1"
				style="background-color: {secondaryColor}"
				data-test="secondary-color"
			/>
		</div>
	{:else if color}
		<div
			data-test="primary-color"
			class="rounded-full h-5 w-5 mr-1"
			style="background-color: {color}"
		/>
	{/if}
	<div>{label}</div>
</div>
